
import { defineComponent, ref } from 'vue'
import TheGrid from './TheGrid.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'EntityNotFound',
  components: {
    TheGrid,
  },
  setup: () => {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
